window.__dmgCmp = window.__dmgCmp || [];
window.addEventListener( 'message', function ( event ) {
	const ns = event.data.ns || {};
	const action = event.data.action || {};
	if ( ns === '@mol-ads/mol-ads-cmp' && action === 'is_loaded' ) {
		// CMP loaded
		cmpLoaded();
	}
} );

function doGDPR () {
	window.__tcfapi( 'addEventListener', 2, tcData => {
		const { eventStatus } = tcData;

		if ( eventStatus === 'useractioncomplete' ) {
			( window.__dmgCmp || ( window.__dmgCmp = [] ) ).push( {
				scope: 'checkVendor',
				data: {
					vendorRegistry: 'nrv', // either 'iab', 'google', or 'nrv'
					vendorId: 33, // their id in one of the 3 registries
					onConsent: () => {
						window.misoConsent = true;
						window.misoCallbacks.forEach( callback => callback() );
					}, // callback whenever user consents or immediately if consent is already known
					onDissent: () => {
						window.misoConsent = false;
						window.misoCallbacks.forEach( callback => callback() );
					}, // same as above but for dissent
					onError: err => {
						console.log( 'error', err );
					},
				},
			} );
		}
	} );

	//Check raw tcData
	window.__tcfapi( 'getTCData', 2, function ( tcData ) {
		if ( tcData ) {
			// Facebook consent
			const fbConsent = tcData.addtlConsent.substring( 2 ).split( '.' ).map( function ( id ) {
				return parseInt( id );
			} ).includes( 89 );

			if ( fbConsent ) {
				dataLayer.push( { event: 'iab_facebook_89' } );
			} else if ( typeof ( fbq ) !== 'undefined' ) {
				fbq( 'consent', 'revoke' );
			}

			// Rakuten consent
			window.__rmcp2 = [];
			for ( const k in tcData.purpose.consents ) {
				if ( tcData.purpose.consents.hasOwnProperty( k ) && tcData.purpose.consents[ k ] ) {
					window.__rmcp2.push( parseInt( k, 10 ) );
				}
			}
		}
	} );

	// Check consentedVendors api
	window.__tcfapi( 'consentedVendors', 2, function ( vendors ) {
		if ( vendors.includes( 755 ) ) {
			//Google ads consent
			dataLayer.push( { event: 'iab_google_ads_755' } );
			document.dispatchEvent( new CustomEvent( 'iab_google_ads_755', { bubbles: true } ) );
			// used in nsweb base code
			window.adsConsent = true;
		}

		if ( vendors.includes( 263 ) ) {
		// Nativo consent
			dataLayer.push( { event: 'iab_nativo_263' } );
		}

		if ( vendors.includes( 60 ) ) {
			// Rakuten consent
			dataLayer.push( { event: 'iab_rakuten_60' } );
		}

		if ( vendors.includes( 1126 ) ) {
			// Microsoft - Bing consent
			dataLayer.push( { event: 'iab_microsoft_1126' } );
		}

		if ( vendors.includes( 274 ) ) {
			// Golden Bees consent
			dataLayer.push( { event: 'iab_goldenbees_274' } );
		}
	} );

	// check Non Registered Vendor list: https://cmp.dmgmediaprivacy.co.uk/nrv/new-scientist/v4/vendor-list.json
	window.__tcfapi( 'getNonRegisteredVendorsConsents', 2, function ( nrvList ) {
		const sailthru = 5; // Sailthru's NRV ID
		if ( nrvList && nrvList[ sailthru ] && nrvList[ sailthru ].consent ) {
			dataLayer.push( { event: 'iab_sailthru_5' } );
		}

		// ABTasty
		const abTastyId = 8; // AB Tasty's NRV ID
		if ( nrvList && nrvList[ abTastyId ] && nrvList[ abTastyId ].consent ) {
			dataLayer.push( { event: 'iab_abtasty_8' } );
		}

		// Chartbeat
		const chartbeat = 9; // Chartbeat's NRV ID
		if ( nrvList && nrvList[ chartbeat ] && nrvList[ chartbeat ].consent ) {
			dataLayer.push( { event: 'iab_chartbeat_9' } );
		}

		// Feefo
		const feefo = 10; // Feefo's NRV ID
		if ( nrvList && nrvList[ feefo ] && nrvList[ feefo ].consent ) {
			dataLayer.push( { event: 'iab_feefo_10' } );
		}

		// Aimwell
		const aimwell = 11; // Feefo's NRV ID
		if ( nrvList && nrvList[ aimwell ] && nrvList[ aimwell ].consent ) {
			dataLayer.push( { event: 'iab_aimwell_11' } );
		}

		// AppCast
		const appCast = 12; // Appcast's NRV ID
		if ( nrvList && nrvList[ appCast ] && nrvList[ appCast ].consent ) {
			dataLayer.push( { event: 'iab_appcast_12' } );
		}

		// TikTok
		const tikTok = 16; // TikTok's NRV ID
		if ( nrvList && nrvList[ tikTok ] && nrvList[ tikTok ].consent ) {
			dataLayer.push( { event: 'iab_tiktok_16' } );
		}

		// Reddit
		const reddit = 21; // Reddit's NRV ID
		if ( nrvList && nrvList[ reddit ] && nrvList[ reddit ].consent ) {
			dataLayer.push( { event: 'iab_reddit_21' } );
		}

		// Alchemer: NSTM-1911
		const alchemer = 28; // Alchemer's NRV ID
		if ( nrvList && nrvList[ alchemer ] && nrvList[ alchemer ].consent ) {
			dataLayer.push( { event: 'iab_alchemer_28' } );
			window.alchemerConsent = true;
			if ( window.alchemerCallbacks && window.alchemerCallbacks.length ) {
				window.alchemerCallbacks.forEach( callback => callback() );
			}
		}

		const miso = 33; // Miso's NRV ID
		if ( nrvList && nrvList[ miso ] && nrvList[ miso ].consent ) {
			dataLayer.push( { event: 'iab_miso_33' } );
			window.misoConsent = true;
		}

		if ( window.misoCallbacks && window.misoCallbacks.length ) {
			window.misoCallbacks.forEach( callback => callback() );
		}
	} );
}

function doCCPA () {
	const ccpaConsent = [
		'1YNN',
		'1---',
	];

	__uspapi( 'getUSPData', 1, function ( uspData, success ) {
		//consented
		if ( success && ( ccpaConsent.includes( uspData.uspString ) || ! uspData.uspString ) ) {
			enableAll();
		} else {
			//dissented
		}
	} );
}

function doNoJurisdiction () {
	enableAll();
}

function enableAll () {
	dataLayer.push( { event: 'iab_facebook_89' } );
	dataLayer.push( { event: 'iab_google_ads_755' } );
	document.dispatchEvent( new CustomEvent( 'iab_google_ads_755', { bubbles: true } ) );
	window.adsConsent = true;
	dataLayer.push( { event: 'iab_nativo_263' } );
	dataLayer.push( { event: 'iab_permutive_361' } );
	document.dispatchEvent( new CustomEvent( 'iab_permutive_361', { bubbles: true } ) );
	dataLayer.push( { event: 'iab_rakuten_60' } );
	dataLayer.push( { event: 'iab_sailthru_5' } );
	dataLayer.push( { event: 'iab_abtasty_8' } );
	dataLayer.push( { event: 'iab_microsoft_1126' } );
	dataLayer.push( { event: 'iab_chartbeat_9' } );
	dataLayer.push( { event: 'iab_feefo_10' } );
	dataLayer.push( { event: 'iab_aimwell_11' } );
	dataLayer.push( { event: 'iab_appcast_12' } );
	dataLayer.push( { event: 'iab_tiktok_16' } );
	dataLayer.push( { event: 'iab_reddit_21' } );
	dataLayer.push( { event: 'iab_alchemer_28' } );
	window.alchemerConsent = true;

	if ( window.alchemerCallbacks && window.alchemerCallbacks.length ) {
		window.alchemerCallbacks.forEach( callback => callback() );
	}

	dataLayer.push( { event: 'iab_miso_33' } );
	window.misoConsent = true;
	if ( window.misoCallbacks && window.misoCallbacks.length ) {
		window.misoCallbacks.forEach( callback => callback() );
	}
}
function cmpLoaded () {
	dataLayer.push( { event: 'cmp_loaded' } );
}

//CMP Queue
window.adverts?.queue?.push( () => {
	if ( window.__tcfapi ) {
		( window.__dmgCmp || ( window.__dmgCmp = [] ) ).push( () => {
			doGDPR();
		} );
	} else if ( window.__uspapi ) {
		doCCPA();
		cmpLoaded();
	} else {
		doNoJurisdiction();
		cmpLoaded();
	}
} );
